import { render, staticRenderFns } from "./EducationLevel.vue?vue&type=template&id=dd820d7c"
import script from "./EducationLevel.vue?vue&type=script&lang=js"
export * from "./EducationLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports